import { NavLink, useNavigate } from "react-router-dom";
import { ReactComponent as Profile } from '../../../../svgs/profile.svg';
import { ReactComponent as Form } from '../../../../svgs/applicationForm.svg';
import { ReactComponent as Status } from '../../../../svgs/applicationStatus.svg';
import { ReactComponent as Payment } from '../../../../svgs/inductionPayment.svg';
import { ReactComponent as Contact } from '../../../../svgs/contactUs.svg';
import { ReactComponent as Logout } from '../../../../svgs/logout.svg';
import { ReactComponent as Print } from '../../../../svgs/printDocument.svg';
import {ReactComponent as Bell} from '../../../../svgs/bell.svg'
import styles from './sideBar.module.scss';
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../../../providers/store";
import {SessionDetails, updateSession} from '../../../../reduxSlice/sessionSlice'
import { updateTabSession } from "../../../../reduxSlice/tabSlice";
import { updatePaymentStatus } from "../../../../reduxSlice/paymentStatus";
import { academicRoute, academicRouteB, corporateRoute, examinationRoute, executiveRoute, militaryRoute, militaryRouteB, practitionerRoute } from "../../../../utils/allRoute";
import { User, updateUserDetails } from "../../../../reduxSlice/useAuthSlice";

interface PaymentStatus {
    ActionName:string;
    Amount:number;
    Status:string;
    
}

const Sidebar = () => {
    const sessionDetails = useSelector((state: RootState) => state?.sessionDetails?.sessionDetails);
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    let activeStyle = {
        backgroundColor: '#11643C', 
        color: '#ffffff',
        fill :  "#fff"
    }

    
    const logout = () => {
        dispatch(updateSession({} as SessionDetails));
        localStorage.removeItem('CIPM-Auth');
        window.localStorage.clear();
        dispatch(updateTabSession("1"));
        dispatch(updatePaymentStatus({} as PaymentStatus));
        dispatch(updateUserDetails({} as User));
        navigate('/login');
    }
    return(
        <nav >  
            <div className={styles.wrapper}>
                <div className={styles.logoWrapper2}>
                    <div className={styles.imageStyle} />
                   
                </div>
                <div className={styles.logoWrapper}>
                    <div className={styles.sidebarText1}><p>
                     {/* eslint-disable-next-line */}
                        {sessionDetails?.RouteId == examinationRoute ? ' Examination/NYSC Route ' : 
                         // eslint-disable-next-line
                    sessionDetails?.RouteId == practitionerRoute ? 'Practitioner Route' : sessionDetails?.RouteId == executiveRoute ?'Executive Route' :
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == academicRoute ? 'Academic Route' : sessionDetails?.RouteId == militaryRoute ? 'Military Route' : 
                     // eslint-disable-next-line
                     sessionDetails?.RouteId == militaryRouteB ? 'Military Route' : sessionDetails?.RouteId == academicRouteB ? 'Academic Route' :
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == corporateRoute ? 'Corporate Route' : '' }</p></div>
                </div>
                
                <div className={styles.logoWrapper}>
                    
                    <div className={styles.sidebarText1}><p>{sessionDetails?.RouteId == corporateRoute ? `${sessionDetails?.CorprateName}` : `${sessionDetails?.FirstName} ${sessionDetails?.LastName}`} </p></div>
                </div>
                <div className={styles.logoWrapper}>
                    <div className={styles.sidebarText2}><p>{sessionDetails?.Occupation}</p></div>
                </div>
              
                {
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == examinationRoute &&
                    <>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/examination-NYSC/profile' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                       
                        {!sessionDetails?.HasPaidAcceptanceFee &&                      
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/examination-NYSC/application-form' className={styles.navLinkStyle}>
                            <Form className={styles.iconWrapper}/> <span>Application Form</span>
                        </NavLink>
                        
                        }
                        {!sessionDetails?.HasPaidAcceptanceFee &&   
                             <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/examination-NYSC/application-status' className={styles.navLinkStyle}>
                             <Status className={styles.iconWrapper}/> <span>Application Status</span>
                         </NavLink>
                        }                  
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/examination-NYSC/print-documents' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/examination-NYSC/contact-us' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>
                    
                }

                {
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == practitionerRoute &&
                    <>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/practitioner/profile' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                        {
                            !sessionDetails?.HasPaidAcceptanceFee &&   
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/practitioner/application-form' className={styles.navLinkStyle}>
                               <Form className={styles.iconWrapper}/> <span>Application Form</span>
                            </NavLink> 
                        }
                        {
                            !sessionDetails?.HasPaidAcceptanceFee &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/practitioner/application-status' className={styles.navLinkStyle}>
                               <Status className={styles.iconWrapper}/> <span>Application Status</span>
                            </NavLink>
                        }                    
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/practitioner/print-documents' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        {
                            sessionDetails?.ActionName === "Training" &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/training-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Training Payment</span>
                            </NavLink>
                        }
                        {
                            sessionDetails?.ActionName==="Induction" &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/induction-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Induction Payment</span>
                            </NavLink>
                        }
                       
                      
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/practitioner/contact-us' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>
                    
                }

                {
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == executiveRoute &&
                    <>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/executive/profile' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                        {
                            !sessionDetails?.HasPaidAcceptanceFee &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/executive/application-form' className={styles.navLinkStyle}>
                                <Form className={styles.iconWrapper}/> <span>Application Form</span>
                            </NavLink>
                        }
                        {
                            !sessionDetails?.HasPaidAcceptanceFee &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/executive/application-status' className={styles.navLinkStyle}>
                                <Status className={styles.iconWrapper}/> <span>Application Status</span>
                            </NavLink>
                        }
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/executive/print-documents' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        {
                            sessionDetails?.ActionName ==="Training" &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/training-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Training Payment</span>
                            </NavLink>
                        }
                        {
                            sessionDetails?.ActionName ===  "Induction" &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/induction-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Induction Payment</span>
                            </NavLink>
                        }
                        
                        
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/executive/contact-us' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>
                    
                }
                  {
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == academicRoute &&
                    <>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/academic/profile' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                    {
                        !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/academic/application-form' className={styles.navLinkStyle}>
                            <Form className={styles.iconWrapper}/> <span>Application Form</span>
                        </NavLink>
                    }
                    {
                        !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/academic/application-status' className={styles.navLinkStyle}>
                            <Status className={styles.iconWrapper}/> <span>Application Status</span>
                        </NavLink>
                    }
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/academic/print-documents' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        {
                            sessionDetails?.ActionName === "Training" &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/training-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Training Payment</span>
                            </NavLink>
                        }
                        {
                            sessionDetails?.ActionName === 'Induction' &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/induction-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Induction Payment</span>
                            </NavLink>
                        }
                       
                       
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/academic/contact-us' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>
                    
                }


                {
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == militaryRoute &&
                    <>
                     <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/military/profile' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                    {
                         !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/military/application-form' className={styles.navLinkStyle}>
                         <Form className={styles.iconWrapper}/> <span>Application Form</span>
                        </NavLink>
                    }
                    {
                         !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/military/application-status' className={styles.navLinkStyle}>
                         <Status className={styles.iconWrapper}/> <span>Application Status</span>
                        </NavLink>
                    }
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/military/print-documents' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        {
                            sessionDetails?.ActionName ==="Training" &&
                            <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/training-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Training Payment</span>
                            </NavLink>
                        }
                        {
                            sessionDetails?.ActionName === 'Induction' &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/induction-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Induction Payment</span>
                             </NavLink>
                        }         
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/military/contact-us' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>                   
                }
                

                {
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == corporateRoute &&
                    <>
                       <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/corporate/profile' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                    {
                        !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/corporate/application-form' className={styles.navLinkStyle}>
                           <Form className={styles.iconWrapper}/> <span>Application Form</span>
                        </NavLink>
                    }
                    {
                        !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/corporate/application-status' className={styles.navLinkStyle}>
                            <Status className={styles.iconWrapper}/> <span>Application Status</span>
                        </NavLink>
                    }
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/corporate/print-documents' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/corporate/contact-us' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>               
                }


{
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == academicRouteB &&
                    <>
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/profile/academic' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                    {
                        !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined} to='/application-form/academic' className={styles.navLinkStyle}>
                            <Form className={styles.iconWrapper}/> <span>Application Form</span>
                        </NavLink>
                    }
                    {
                        !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/application-status/academic' className={styles.navLinkStyle}>
                            <Status className={styles.iconWrapper}/> <span>Application Status</span>
                        </NavLink>
                    }
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/print-documents/academic' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        {
                            sessionDetails?.ActionName === "Training" &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/training-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Training Payment</span>
                            </NavLink>
                        }
                        {
                            sessionDetails?.ActionName === 'Induction' &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/induction-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Induction Payment</span>
                            </NavLink>
                        }
                       
                       
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/contact-us/academic' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>
                    
                }


{
                     // eslint-disable-next-line
                    sessionDetails?.RouteId == militaryRouteB &&
                    <>
                     <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/profile/military' className={styles.navLinkStyle}>
                            <Profile className={styles.iconWrapper}/> <span>Profile</span>
                        </NavLink>
                    {
                         !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/application-form/military' className={styles.navLinkStyle}>
                         <Form className={styles.iconWrapper}/> <span>Application Form</span>
                        </NavLink>
                    }
                    {
                         !sessionDetails?.HasPaidAcceptanceFee &&
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/application-status/military' className={styles.navLinkStyle}>
                         <Status className={styles.iconWrapper}/> <span>Application Status</span>
                        </NavLink>
                    }
                        <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/print-documents/military' className={styles.navLinkStyle}>
                            <Print className={styles.iconWrapper}/> <span>Print Documents</span>
                        </NavLink>
                        {
                            sessionDetails?.ActionName ==="Training" &&
                            <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/training-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Training Payment</span>
                            </NavLink>
                        }
                        {
                            sessionDetails?.ActionName === 'Induction' &&
                            <NavLink style={({isActive}) => isActive ? activeStyle : undefined}  to='/induction-payment' className={styles.navLinkStyle}>
                            <Payment className={styles.iconWrapper}/> <span>Induction Payment</span>
                             </NavLink>
                        }         
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/notification' className={styles.navLinkStyle}>
                            <Bell className={styles.iconWrapper}/> <span>Notification</span>
                        </NavLink>
                        <NavLink  style={({isActive}) => isActive ? activeStyle : undefined}  to='/contact-us/military' className={styles.navLinkStyle}>
                            <Contact className={styles.iconWrapper}/> <span>Contact Us</span>
                        </NavLink>
                    </>                   
                }
                


              
                <div
                 onClick={logout}
                 className={styles.footerLinkStyle}>
                    <Logout  className={styles.iconWrapper} /> <span>Logout</span>
                </div>
            </div>
        </nav>
    )
};

export default Sidebar



